import { FC } from "react";
import { CircleX } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import StatusScreen from "@/app/contract-updates/components/status-screen";

interface Props {
  onReview: () => void;
}

const RefusedQuoteScreen: FC<Props> = ({ onReview }) => {
  const { t } = useTranslation(["quote-refusal"]);

  return (
    <div className="follo-card flex min-h-[420px] py-10">
      <StatusScreen
        icon={<CircleX className="size-10 text-rose-600" />}
        iconBg="bg-rose-100"
        title={t("quote-refusal:refused-title", "Quote declined")}
        description={t(
          "quote-refusal:refused-description",
          "If you change your mind, you can still review this quote and accept it.",
        )}
        footer={
          <Button className="cursor-pointer" variant="outline" onClick={onReview}>
            {t("quote-refusal:refused-review", "Review the quote again")}
          </Button>
        }
      />
    </div>
  );
};

export default RefusedQuoteScreen;
